import { colorConstants } from 'config/colorConstants';
import React, { FC } from 'react';
import { calculateFontSize } from 'utils/helperMethods';

interface Props {
    value: number | string;
    color?: string; // if its undefined no color will be applied
    style?: React.CSSProperties;
}
const scaledWidth = calculateFontSize(window.innerWidth, 100);

const Scorecard: FC<Props> = ({ value, color, style = {} }) => {
    if (!value) return null;
    return (
        <div
            className="font-xs"
            style={{
                background: color,
                color: colorConstants.blackAlt,
                borderRadius: 4,
                paddingBlock: 7,
                width: scaledWidth,
                fontWeight: 500,
                textAlign: 'center',
                ...style,
            }}
        >
            {value}
        </div>
    );
};

export default Scorecard;
